import gatekeeperRequest from '@/utils/gatekeeperRequest'
import tokens from '@/utils/tokens'

type FinJwtResponse = {
  token: string
}

const fetchFinJwt = async (): Promise<string> => {
  const jwt = await tokens.getCurrentOrNewJWT()
  const response = await gatekeeperRequest({
    method: 'POST',
    url: '/fin/jwt',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }) as { data: FinJwtResponse }

  return response.data.token
}

export default fetchFinJwt
